module.exports = __webpack_public_path__ + "static/media/thani.1294a232.jpg";